import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarFill } from '@fortawesome/free-solid-svg-icons';
import React from "react";
import "./index.scss";
const Head = ({ data }) => {
	return (
		<>
          {/*div className="head text-center">
				<h4>Current Highlighted Document</h4>
				<div className="icon text-center">
					<span className="d-inline-flex position-relative">
						<img className="img-fluid" src={require('../../../../../assets/img/file-dollar-icon.svg')} alt="Dollar" />
						  <img className="img-fluid" src={require('../../../../../assets/img/file-home-icon.svg')} alt="Home" />
						<img className="img-fluid" src={require('../../../../../assets/img/file-user-icon.svg')} alt="User" />  
					</span>
				</div>
				<label>Asset</label>
			</div> */}
			{ <div className="head">
				<div className="icon text-center">
					<span className="d-inline-flex position-relative">
						<img className="img-fluid" src={data?.type_info?.icon ? data?.type_info?.icon : require(`../../../../../assets/img/icons/unlabeled.png`)} alt="File" />
						{<span className={`bookmark-icon position-absolute d-inline-flex align-items-center justify-content-center rounded-circle ${data.favorite ? 'active' : ''}`}>
							<FontAwesomeIcon icon={data.favorite ? faStarFill : faStar} />
						</span>}
					</span>
				</div>
				<label>{data.name}</label>
				<span className="d-block">{data.size}</span>
			</div>}
		</>
	);

}

export default Head;